interface PropFirmLogos {
  [key: string]: {
    logo: string;
    icon: string;
  };
}

const propFirmLogos: PropFirmLogos = {
  cti: {
    logo: "/assets/logos/cti/logo.svg",
    icon: "/assets/logos/cti/icon.svg"
  },
  ttp: {
    logo: "/assets/logos/ttp/logo.svg",
    icon: "/assets/logos/ttp/icon.svg"
  },
  fxify: {
    logo: "/assets/logos/fxify/logo.svg",
    icon: "/assets/logos/fxify/icon.svg"
  },
  "alpha-capital": {
    logo: "/assets/logos/alpha-capital/logo.svg",
    icon: "/assets/logos/alpha-capital/icon.svg"
  },
  e8: {
    logo: "/assets/logos/e8/logo.svg",
    icon: "/assets/logos/e8/icon.svg"
  },
  "for-traders": {
    logo: "/assets/logos/for-traders/logo.svg",
    icon: "/assets/logos/for-traders/logo.svg"
  },
  "seacrest-funded": {
    logo: "/assets/logos/seacrest-funded/logo.svg",
    icon: "/assets/logos/seacrest-funded/logo.svg"
  },
  tradingplus: {
    logo: "/assets/logos/tradingplus/logo.svg",
    icon: "/assets/logos/tradingplus/logo.svg"
  },
  wmt: {
    logo: "/assets/logos/wmt/logo.svg",
    icon: "/assets/logos/wmt/logo.svg"
  },
  "blueberryfunded": {
    logo: "/assets/logos/blueberryfunded/logo.svg",
    icon: "/assets/logos/blueberryfunded/logo.svg"
  },
  "blueguardian": {
    logo: "/assets/logos/blueguardian/logo.svg",
    icon: "/assets/logos/blueguardian/logo.svg"
  }
};

export { propFirmLogos };
